export default "__VITE_ASSET__9iyQCaId__"